import OverlayLayer from '../OverlayLayer/OverlayLayer';
import './ModalCollection.scss';
import { featureToggleCollectionVisibility } from './featureToggleCollectionVisibility';

interface ModalCollectionProps {
    defaultItemId: string;
    items: {
        id: string;
        name: string;
        color?: string;
        visible?: boolean;
        opacity?: number;
        data_category_id: string; // see: data_collection table and then data_category table
    }[];
    disabled: boolean;
}

interface ModalCollectionCallbacks {
    onChangeItem: (id: string) => void;
    onChangeColor: (id: string, color: string) => void;
    onChangeVisibility: (id: string, visible: boolean, opacity: number) => void;
}

export class ModalCollection {
    private readonly root: HTMLElement;
    private callbacks: ModalCollectionCallbacks;
    private overlay: any;
    private handlerOnClickOutside: Function | null;
    private props: ModalCollectionProps;
    private visibilitySteps: { opacity: number; className: string }[];

    constructor(
        root: HTMLElement,
        props: ModalCollectionProps,
        callbacks: ModalCollectionCallbacks
    ) {
        this.root = root;
        this.callbacks = callbacks;
        this.props = props;
        this.visibilitySteps = [
            { opacity: 1, className: 'icon-on' },
            // { opacity: 0.5, className: 'icon-half-opacity' },
            { opacity: 0, className: 'icon-off' },
        ];

        this.overlay = OverlayLayer(
            'ModalCollection',
            {
                onClick: () => {
                    this.hide();
                },
            },
            20000
        );

        this.handlerOnClickOutside = null;
        this.hide();
        this.reload();
    }

    getDescription(): string {
        // return `<div>${JSON.stringify(this.props.items)} - ${this.props.defaultItemId}</div>`;
        return `<div>${this.props.items.filter(i => i.id == this.props.defaultItemId)[0].name}</div>`;
    }

    setModalPosition(): void {
        this.root.style.left = '250px';
        this.root.style.top = '69px';
        this.root.style.position = 'absolute';
        this.root.style.zIndex = '20001';
    }

    show(): void {
        // console.log('ModalFilterEditor show()');
        this.root.style.display = 'block';
        this.setModalPosition();
        this.overlay.show();
    }

    hide(): void {
        // console.log('parentRects, hide');
        this.root.style.display = 'none';
        this.overlay.hide();
    }

    reload(): void {
        this.root.innerHTML = this.getHTML();

        this.populateItems();

        // Set event when user click outside of the modal, then cancel all changes and close window
        if (this.handlerOnClickOutside === null) {
            this.handlerOnClickOutside = e => {
                if (e.target === this.root) {
                    this.hide();
                }
            };
            this.root.addEventListener('click', this.handlerOnClickOutside as any);
            // this.root.addEventListener('cancel', this.handlerOnClickOutside as any);
        }
    }

    populateItems(): void {
        const modalCollection = this.root.querySelector('.modal-collection');
        if (modalCollection) {
            modalCollection.innerHTML = '';
            this.props.items.sort((a, b) => a.name.localeCompare(b.name));

            this.props.items.forEach(item => {
                const itemElement = document.createElement('div');
                let visibilityToggler = new featureToggleCollectionVisibility(
                    this.visibilitySteps,
                    1
                );
                let iconVisibilityClass = visibilityToggler.getVisibilityClassName();

                itemElement.classList.add('modal-collection-item');
                itemElement.innerHTML = `
                    <div class="modal-collection-item-icon data_category_id_${item.data_category_id}"><i class="mdi mdi-layers"></i></div>
                    <div class="modal-collection-item-name">${item.name}</div>
<!--                    <div class="modal-collection-item-visibility ${iconVisibilityClass}" data-opacity="${item.opacity}"></div>-->
<!--                    <div class="modal-collection-item-color" style="background-color: ${item.color || '#fff'}"></div>-->
                `;

                let colorElement = itemElement.querySelector(
                    '.modal-collection-item-color'
                ) as HTMLDivElement;
                if (colorElement) {
                    colorElement.addEventListener('click', e => {
                        e.stopPropagation();
                        console.log('modal-collection-item-color click');
                        // this.callbacks.onChangeColor(item.id, item.color || '#fff');
                    });
                }

                itemElement.addEventListener('click', e => {
                    this.callbacks.onChangeItem(item.id);
                    this.hide();
                });
                modalCollection.appendChild(itemElement);

                let visibilityElement = itemElement.querySelector(
                    '.modal-collection-item-visibility'
                ) as HTMLDivElement;
                if (visibilityElement) {
                    visibilityElement.addEventListener('click', e => {
                        e.stopPropagation();
                        let el = e.target as HTMLDivElement;

                        console.debug(
                            'visibilityToggler.getVisibilityClassName(), removing className: ',
                            visibilityToggler.getVisibilityClassName()
                        );

                        el.classList.remove(visibilityToggler.getVisibilityClassName());

                        visibilityToggler.setNextVisibilityStep();

                        el.setAttribute('data-opacity', visibilityToggler.getOpacity().toString());
                        el.classList.add(visibilityToggler.getVisibilityClassName());
                        // Targeo.Base.Map.modules['modGeoMultiCollection'].changeColor(cid, clr);
                        // Targeo.Base.Map.modules['modGeoMultiCollection'].setShowCollection(jQ(this).data('cid'), this.checked);
                        this.callbacks.onChangeVisibility(
                            item.id,
                            visibilityToggler.isVisible(),
                            visibilityToggler.getOpacity()
                        );
                    });
                }
            });
        }
    }

    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dialog
    getHTML(): string {
        return `
                    <div class="modal-collection"></div>
            `;
    }
}
